exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#infobits-content{flex:auto;display:flex;min-height:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3e9f2035!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/infobits-content.vue
// module id = 87
// module chunks = 0